<template v-loading="loading">
  <div style="height: 100%;overflow: auto;">
    <div class="search-header">
      <el-input style="width: 300px;" placeholder="请输入缓存key" v-model="cacheKey"></el-input>
      <el-button @click="searchCache" style="margin-left: 20px;">搜索</el-button>
      <el-button @click="handleDeleteSelected" style="margin-left: 20px;">批量删除</el-button>
      <template v-if="cacheData && cacheData !== null && cacheData.length > 0">
        <span class="tip-message">共有<span class="red">{{ cacheData.length }}</span>条缓存</span>
        <span class="tip-message">选中<span class="red">{{ multipleSelection.length }}</span>条</span>
      </template>
    </div>
    <div class="cache-body" v-if="cacheData && cacheData !== null && cacheData.length > 0">
      <el-table
        ref="multipleTable"
        border
        :data="cacheData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          align="center"
          width="55">
        </el-table-column>
        <el-table-column
          prop="key"
          label="key"
          align="center"
          width="400">
        </el-table-column>
        <el-table-column
          prop="value"
          label="值"
          align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          width="100"
          align="center">
          <template slot="header" slot-scope="scope">
            操作
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.key)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'

  export default {
    name: 'redis-cache-manage',
    data() {
      return {
        cacheData: [],
        cacheKey: '',
        multipleSelection: [],
        loading: false
      }
    },
    methods: {
      searchCache: function() {
        this.loading = true
        util.ajax.get('/entity/dev/cache/searchCache?cacheKey=' + this.cacheKey).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.cacheData = res.data.data
            this.loading = false
          } else {
            this.$message.warning(res.data.meta.errMsg)
            this.loading = false
          }
        }).catch(err => {
          console.error(err)
          this.$message.error('系统错误')
          this.loading = false
        })
      },
      handleDelete: function(key) {
        this.loading = true
        util.ajax.post('/entity/dev/cache/removeCache', {
          params: {
            keys: [key]
          }
        }).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.searchCache()
          } else {
            this.$message.warning(res.data.meta.errMsg)
            this.loading = false
          }
        }).catch(err => {
          console.warn(err)
          this.$message.error('系统错误')
          this.loading = false
        })
      },
      handleDeleteSelected: function() {
        this.$confirm('您是否要删除选中的缓存？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          let selectedKey = []
          for (let i = 0; i < this.multipleSelection.length; i++) {
            selectedKey[i] = this.multipleSelection[i].key
          }
          util.ajax.post('/entity/dev/cache/removeCache', {
            params: {
              keys: selectedKey
            }
          }).then(res => {
            if (res.data.meta && res.data.meta.errCode === 0) {
              this.searchCache()
            } else {
              this.$message.warning(res.data.meta.errMsg)
              this.loading = false
            }
          }).catch(err => {
            console.warn(err)
            this.$message.error('系统错误')
            this.loading = false
          })
        }).catch()
      },
      handleSelectionChange: function(val) {
        this.multipleSelection = val
      }
    }
  }
</script>

<style scoped>

  .search-header {
    width: 85%;
    margin: 20px auto;
  }

  .cache-body {
    width: 85%;
    margin: 20px auto;
  }

  .tip-message {
    font-size: 14px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/grid/develop/redis-cache-manage.vue